import { z } from "zod/v4";
import { subscriptionTierSchema } from "./shared";

export const userRoleSchema = z.enum(["super_admin", "admin", "bis", "club_owner", "user"]);

export const sessionSchema = z.object({
	user_id: z.string(),
	role: userRoleSchema,
	club_ids: z
		.array(z.string())
		.nullable()
		.transform((v) => v ?? []),
	// Per-club subscription tier (club_id → tier) carried on the JWT. A missing
	// entry means the free tier; consumers default accordingly.
	club_tiers: z
		.record(z.string(), subscriptionTierSchema)
		.nullable()
		.transform((v) => v ?? {}),
});

// A Firebase custom token for the caller; a sibling portal trades it for its own session.
export const handoffTokenSchema = z.object({
	token: z.string().min(1),
});
